import type { CSSProperties } from 'react';

interface Props {
  initials?: string | null;
  color?: string | null;
  size?: number;
  style?: CSSProperties;
}

export function Avatar({ initials, color, size = 24, style }: Props) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: color ?? 'var(--accent)',
        color: '#fff',
        fontSize: Math.round(size * 0.42),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        flexShrink: 0,
        letterSpacing: 0.3,
        ...style,
      }}
    >
      {initials || '··'}
    </div>
  );
}

export function initialsFor(name: string): string {
  return name
    .split(' ')
    .map((x) => x[0] ?? '')
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

// Deterministic color from a string — used when the server doesn't give us an
// explicit agentColor (v1 conversations don't carry one).
const AGENT_COLORS = [
  '#c56b45', // warm orange (accent)
  '#3a7d8c', // teal
  '#8b5cf6', // violet
  '#2f855a', // green
  '#1f6feb', // blue
  '#b45309', // amber
  '#6b21a8', // purple
  '#0f766e', // emerald
  '#9f1239', // rose
];

export function colorForSeed(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return AGENT_COLORS[Math.abs(hash) % AGENT_COLORS.length]!;
}
